export function getMP4Support(): string {
    const c = document.cookie.split("; ").find(s => s.startsWith("support_mp4"));
    return c ? c.split("=")[1] : "";
  }